export default __webpack_public_path__ + "static/layout-anatomy-dark-85304631f48a3f015afe6aa998fc53ec.png";